/* eslint-disable no-useless-escape */
import merge from 'lodash/merge'
import sortBy from 'lodash/sortBy'
// import moment from 'moment'
import { differenceInYears, parse } from 'date-fns'
import constants from 'constants'

const regexEmail = /([a-zA-Z0-9_.-]+)@([\da-zA-Z.-]+)\.([a-zA-Z.]{2,6})/
const regexPhone = /(^0[2|3|7|8]{1}[0-9]{8}$)/
const regexMobile = /(^04\d{2}\d{6}$)/
const regexCard = /^(\d{14,16})$/
const regexCCV = /^(\d{3,4})$/
const regexABN = /^(\d *?){11}$/
const regexBSB = /^\d{6}$/
const regexAccountNumber = /^\d{6,10}$/
// eslint-disable-next-line no-useless-escape
const regexTextUnicode = /^[a-zA-Z,\.\'\`\-\u00A0-\u00FF\s]+$/
// const regexAlpha = /^[\w\-\s]+$/
const regexAlphaWithSpecialChars = /^[()-@.\'\/#&+\w\s]*$/

// Min & CHaracters and at least one Alpha Character
const regexPasswordRequiremets = /^(?=.*[0-9])(?=.*[a-zA-Z])([\S\s]){8,}$/

// http://stackoverflow.com/a/15504877/132164
// dd/mm/yy regex that also checks the right number of days per month (incl. leap years)
/* eslint-disable */
const regexDDMMYY = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[1,3-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
/* eslint-enable */

/* Test a given regex againt a given value
   Return true | false
*/
const regexTest = (regex, value) => {
  if (value === '') {
    return true
  }

  return regex.test(value)
}

/* Validation object
   Returns an object with default properties or with updated values
*/
const validationObj = ({
  error,
  valid = false,
  condition,
}) => {
  return {
    error: error || 'This field is required',
    valid,
    condition,
  }
}

/* Validation rules used for validating different form values
   Returns a validation objed with information about the validation.
*/
export default class Validators {
  static required(val = '', error = null) {
    const valid = (String(val).trim().length > 0)

    return validationObj({
      valid,
      error,
    })
  }

  static objectWithValue(val = '', error = null) {
    const valid = (typeof val === 'object' && val.value)

    return validationObj({
      valid,
      error,
    })
  }

  static either(val1 = '', val2 = '', key1, key2, error = null) {
    const valid = !((!val1 || val1.length === 0) && (!val2 || val2.length === 0))
    // ('@@@ valid:', valid, ', val1: ', (String(val1) === ''), ', val2: ', (String(val2) === ''), ', key1: ', key1, ', key2: ', key2)
    return validationObj({
      condition: key2,
      valid,
      error,
    })
  }

  static requiredNumberIf(val1, val2, key1, key2, error = null, conditions) {
    const validCondition = (val2 === conditions)
    // ('@@@ validCondition:', validCondition, ', val1: ', (String(val1) === ''), '-', val1, ', val2: ', (String(val2) === '', '-', val2), ', key1: ', key1, ', key2: ', key2, ', condition: ', conditions)
    let valid = true
    if (validCondition) {
      // eslint-disable-next-line no-restricted-globals
      valid = (!(val1 === '' || isNaN(val1) || val1 === null)) && Number(val1) > 0
    }

    return validationObj({
      valid,
      error,
    })
  }

  static requiredIf(val1, val2, key1, key2, error = null, conditions) {
    const validCondition = (val2 === conditions)
    let valid = true
    if (validCondition) {
      valid = (String(val1).trim().length > 0)
    }

    return validationObj({
      valid,
      error,
    })
  }

  static requiredCheckedIf(val1, val2, key1, key2, error = null, conditions) {
    const validCondition = (val2 === conditions)
    let valid = true
    // ('@@@ validCondition:', validCondition, ', val1: ', (String(val1) === ''), '-', val1, ', val2: ', (String(val2) === '', '-', val2), '-', val1)
    if (validCondition) {
      valid = (val1 === true)
    }

    return validationObj({
      valid,
      error,
    })
  }

  static requiredCheckedIfs(val1, val2, val3, key1, key2, key3, error = null, conditions) {
    const condition = conditions.split('|')
    const condition1 = condition[0]
    const condition2 = condition[1]
    const validCondition = (val2 === condition1 && val3 === condition2)
    let valid = true
    // ('@@@ validCondition:', validCondition, ', val1: ', (String(val1) === ''), '-', val1, ', val2: ', (String(val2) === '', '-', val2), '-', val1, ', val3: ', (String(val3) === '', '-', val3), ', key1: ', key1, ', key2: ', key2, ', condition 1: ', condition1, ', condition 2: ', condition2)
    if (validCondition) {
      valid = (val1 === true)
    }

    return validationObj({
      valid,
      error,
    })
  }

  static requiredIfs(val1, val2, val3, key1, key2, key3, error = null, conditions) {
    const condition = conditions.split('|')
    const condition1 = condition[0]
    const condition2 = condition[1]
    const validCondition = (val2 === condition1 && val3 === condition2)
    // ('@@@ validCondition:', validCondition, ', val1: ', (String(val1) === ''), '-', val1, ', val2: ', (String(val2) === '', '-', val2), '-', val1, ', val3: ', (String(val3) === '', '-', val3), ', key1: ', key1, ', key2: ', key2, ', condition 1: ', condition1, ', condition 2: ', condition2)
    let valid = true
    if (validCondition) {
      valid = (String(val1).trim().length > 0)
    }

    return validationObj({
      valid,
      error,
    })
  }

  static valueCheck(val, val2) {
    return val === val2
  }

  // Should this also take the value of the actual input????
  // as it also needs to check if a value is actual suprised
  static setRequirement(val, conditions, error = null) {
    let isRequired = true

    conditions.filter(con => con.priority !== 1).forEach((con) => {
      if (con.valid) {
        isRequired = false
      }
    })

    conditions.filter(con => con.priority === 1).forEach((con) => {
      if (con.valid) {
        isRequired = false
      }
    })

    if (isRequired) {
      const check = Validators.required(val)

      return validationObj({
        valid: check.valid,
        error,
      })
    }

    return validationObj({
      valid: !isRequired,
      error,
    })
  }

  static equalTo(val, val2, key1, key2, error = null) {
    const valid = (String(val) === String(val2))

    return validationObj({
      condition: key2,
      valid,
      error,
    })
  }

  static bound(val, val2, key1, key2, error = null) {
    return validationObj({
      condition: key2,
      valid: true,
      error,
    })
  }

  static passwordRequirements(val, val2, key1, key2, error = null) {
    const valid = (regexTest(regexPasswordRequiremets, val) && regexTest(regexPasswordRequiremets, val2))

    return validationObj({
      condition: key2,
      valid,
      error,
    })
  }

  static requiredNumber(val, error = null) {
    // eslint-disable-next-line no-restricted-globals
    const valid = (!(val === '' || isNaN(val) || val === null)) && Number(val) > 0

    return validationObj({
      valid,
      error,
    })
  }

  static requiredTFN(val, error = null) {
    // eslint-disable-next-line no-restricted-globals
    const valid = (!(val === '' || isNaN(val) || val === null || val.length < 8 || val.length > 9)) || val === 0

    return validationObj({
      valid,
      error,
    })
  }

  static isNameValid(val, error = null) {
    const valid = regexTest(regexAlphaWithSpecialChars, val)

    return validationObj({
      valid,
      error,
    })
  }

  static isEmail(val, error = null) {
    const valid = regexTest(regexEmail, val)

    return validationObj({
      valid,
      error,
    })
  }

  static isPhone(val = '', error = null) {
    const valid = (val.length) ? regexTest(regexPhone, val) : true

    return validationObj({
      valid,
      error,
    })
  }

  static isMobile(val = '', error = null) {
    const valid = (val.length) ? regexTest(regexMobile, val) : true

    return validationObj({
      valid,
      error,
    })
  }

  static isCard(val, error = null) {
    const valid = regexTest(regexCard, val)

    return validationObj({
      valid,
      error,
    })
  }

  static isAccountNumber(val, error = null) {
    const valid = regexTest(regexAccountNumber, val)
    return validationObj({
      valid,
      error,
    })
  }

  static isAccountNumberIf(val1, val2, key1, key2, error = null, condition) {
    const validCondition = (val2 === condition)
    let valid = true
    if (validCondition) {
      valid = regexTest(regexAccountNumber, val1)
    }
    return validationObj({
      valid,
      error,
    })
  }

  static isAmountOverdrawn(val1, val2, key1, key2, error = null) {
    // eslint-disable-next-line no-restricted-globals
    const valid = ((Number(val1) <= Number(val2)) && ((!(val2 === '' || isNaN(val2) || val2 === null)) || val2 > 0))
    return validationObj({
      valid,
      error,
    })
  }

  static isDistributionAmountValid(val1, val2, key1, key2, error = null) {
    // eslint-disable-next-line no-restricted-globals
    const valid = ((Number(val1) <= Number(val2)) && ((!(val2 === '' || isNaN(val2) || val2 === null)) || val2 > 0))
    return validationObj({
      valid,
      error,
    })
  }

  static isTextUnicode(val, error = null) {
    const valid = regexTest(regexTextUnicode, val)
    return validationObj({
      valid,
      error,
    })
  }

  static isBSB(val, error = null) {
    const valid = regexTest(regexBSB, val)

    return validationObj({
      valid,
      error,
    })
  }

  static isBirthdate(val, error = null) {
    // const age = moment().diff(val, 'years')
    const date = parse(val, constants.DATE_FORMAT.STANDARD, new Date())
    const age = differenceInYears(new Date(), date)

    const valid = (age > 0)

    return validationObj({
      valid,
      error,
    })
  }

  static isCCV(val, error = null) {
    const valid = regexTest(regexCCV, val)

    return validationObj({
      valid,
      error,
    })
  }

  static isCardType(val, error = null) {
    let valid = false

    switch (val) {
      case 'visa':
      case 'master-card':
      case 'american-express':
        valid = true
        break
      default:
        valid = false
        break
    }

    return validationObj({
      valid,
      error,
    })
  }

  static isABN(val, error = null) {
    const valid = regexTest(regexABN, val)

    return validationObj({
      valid,
      error,
    })
  }

  static dateFormatDMY(val = '', error = null) {
    const valid = regexTest(regexDDMMYY, val)
    return validationObj({
      valid,
      error,
    })
  }

  static isCounsellorCommentRequired(val1, val2, val3, key1, key2, key3, error = null, conditions) {
    // eslint-disable-next-line no-restricted-globals
    const condition = conditions.split('|')
    const condition1 = condition[0]
    const condition2 = condition[1]
    const validCondition = (val2 === condition1 && val3 === condition2)
    // ('@@@ validCondition:', validCondition, ', val1: ', (String(val1) === ''), '-', val1, ', val2: ', (String(val2) === '', '-', val2), '-', val1, ', val3: ', (String(val3) === '', '-', val3), ', key1: ', key1, ', key2: ', key2, ', condition 1: ', condition1, ', condition 2: ', condition2)
    let valid = true
    if (validCondition) {
      valid = (val1 === val2) || (val1 !== val2 && val3 !== '')
    }

    return validationObj({
      valid,
      error,
    })
  }
}

/* Validate a value against its given Validation rules.
   Return an and error object if errors are found.
*/
const valueCheck = (requiredObj, value, values) => {
  let errorObj = {}
  let hasError = false
  const validators = sortBy(requiredObj.validators, 'priority')
  const defaultError = requiredObj.error

  validators.forEach(({
    check, fields, error, conditions,
  }) => {
    let outcome
    const message = error || defaultError
    if (fields) {
      const keys = fields.split('|')
      if (keys.length === 3) {
        const key1 = keys[0]
        const key2 = keys[1]
        const key3 = keys[2]
        outcome = Validators[check](values[key1].value, values[key2].value, values[key3].value, key1, key2, key3, message, conditions)
      } else {
        const key1 = keys[0]
        const key2 = keys[1]
        outcome = Validators[check](values[key1].value, values[key2].value, key1, key2, message, conditions)
      }
    } else if (conditions) {
      const evalualtedConditions = conditions.map(condition => ({
        ...condition,
        valid: Validators.valueCheck(values[condition.name][condition.key], condition.value),
      }))
      outcome = Validators[check](value, evalualtedConditions, message)
    } else {
      outcome = Validators[check](value, message)
    }

    errorObj.name = requiredObj.name

    if (!hasError) {
      errorObj = merge(errorObj, outcome)
    }

    if (outcome.valid === false && !hasError) {
      hasError = true
      errorObj = merge(errorObj, outcome)
    }
  })

  return errorObj
}

export const validateAll = (requiredFields, values) => {
  const errors = []

  Object.keys(values).forEach((key) => {
    const val = values[key].value

    requiredFields.forEach((obj) => {
      if (key !== obj.name) {
        return
      }

      const check = valueCheck(obj, val, values)

      // Add to errors value didnt pass its check
      if (check && !check.valid) {
        errors.push(check)
      }
    })
  })

  return errors
}

export const validateField = (requiredFields, name, value, values) => {
  let errors

  requiredFields.forEach((obj) => {
    if (name !== obj.name) {
      return
    }

    const check = valueCheck(obj, value, values)

    if (check) {
      errors = check
    }
  })

  return errors
}



// WEBPACK FOOTER //
// ./src/utils/validators.js